<template>
  <div class="marker-window">
    <v-btn class="window-input" @click="onClick()">{{lat}},{{lng}}</v-btn>
  </div>
</template>
<script>
  export default {
    props: {
      snackbar: Boolean,
      dialog: Boolean,
      lat: Number,
      lng: Number
    },
    methods: {
      onClick () {
        this.$emit('update:snackbar', false);
        this.$emit('update:dialog', true);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// MarkerWindow.vue?3ccaa2c8